module.exports = __webpack_public_path__ + "assets/images/crate-step2.6b026099.jpg";